import Logger from '../Logger';

/**
 * IdentityManager.
 * Helps to tracks identity across collection platform
 *
 * @copyright Realeyes OU. All rights reserved.
 */

import SessionLevelIdentityInfo from './SessionLevelIdentityInfo';

export default class IdentityService {
    /**
     * Creates IdentityManager instance.
     * @param {ConfigurationManager} configurationManager entity to get configuration
     */
    constructor(configurationManager) {
        const { config } = configurationManager;
        this.logger = new Logger('IS', configurationManager.isDebugMode());
        if (config) {
            this.externalSessionId = config.sessionId;
            this.externalParticipantId = config.participantId;
            this.externalProjectId = config.projectKey;
            this.logger.logDebug(`identity setup from config as ${
                JSON.stringify(new SessionLevelIdentityInfo(
                    this.externalSessionId,
                    this.externalParticipantId,
                    this.externalProjectId,
                ))} `);
        }
    }

    /**
     * Creates IdentityManager instance.
     * @param {string} sessionGuid entity to get configuration
     * @return {void}
     */
    setSessionGuid(sessionGuid) {
        this.externalSessionId = sessionGuid;
    }

    /**
     * returns current session level identitties
     * @return{SessionLevelIdentityInfo}
     */
    getSessionLevelIdentity() {
        // todo: use Promise and generate/get session and participant ids
        return new SessionLevelIdentityInfo(this.externalSessionId, this.externalParticipantId, this.externalProjectId);
    }
}
